// src/data/identityGraph.ts
// Identity Graph summary statistics — reflects actual SIG Q3 2025 data

export const identityGraphStats = {
  // Core individual base
  individuals: 498_670_192,
  households: 498_670_192, // 1:1 with individuals in current graph
  addresses: 498_670_192,
  nationalConsumerDatabase: 253_608_863, // 54.1% validated against NCD

  // Email universe
  email: {
    totalEmailIds: 1_738_162_543,
    actualAddresses: 725_546_382,
    md5Hashed: 1_245_957_378,
    sha256Hashed: 0, // available but count TBD
    optIn: 458_363_294, // consent for 3rd party activation
  },

  // Phone universe
  phone: {
    total: 899_270_341,
    cell: 254_806_258,
    landline: 613_589_418,
    voip: 30_874_665,
  },

  // Mobile device IDs (MAIDs)
  mobileDevices: {
    total: 5_880_567_984,
    android: 3_113_073_899, // AAID
    apple: 2_767_494_085,   // IDFA
  },

  // Connected TV
  ctv: {
    totalIFA: 23_350_254_749,
    linkedToIdentity: 17_420_151_450, // 74.6% match rate
    matchRate: 0.746,
  },

  // IP addresses
  ipAddresses: {
    total: 14_557_350_909,
    residential: 2_997_583_486,  // 20.6%
    commercial: 1_437_900_672,   // 9.9%
    mobileTower: 10_121_866_751, // 69.5%
  },

  // Behavioral & intent
  behavioral: {
    iabRecords: 7_456_350_021,
    ncdLinked: 6_197_109_563, // 83.1% linked to validated identity
  },

  intentSignals: {
    b2cWeekly: 4_890_748_682,
    b2bWeekly: 20_614_301_460,
    totalWeekly: 25_505_050_142,
    b2cTopics: 8_305,
    b2cCategories: 25,
    b2cSubcategories: 206,
  },

  // Supplemental data layers
  property: {
    totalProperties: 194_544_036,
    linkedToIndividual: 125_826_361, // 64.7%
    linkedToSecondaryOwner: 34_172_249,
  },

  financial: {
    totalRecords: 475_647_124,
    autoLoanIntent: 224_259_778,    // 47.1%
    autoOfferResponse: 164_377_692, // 34.6%
    bankCardIntent: 47_496_991,     // 10.0%
    cardOfferResponse: 190_788_581, // 40.1%
    mortgageNewIntent: 8_056_895,   // 1.7%
    creditScored: 153_329_520,      // 32.7% with credit tier
    medianIncomeAvailable: 354_411_094, // 75.5%
  },

  executiveAtHome: {
    totalExecutives: 121_163_642,
    linkedToConsumerIdentity: 56_671_271, // 46.8%
  },

  consumerData: {
    totalRecords: 469_199_058,
    totalAttributes: 2_167,
    categories: [
      { name: 'Demographic', attributes: 483 },
      { name: 'Transactional', attributes: 408 },
      { name: 'Occupations', attributes: 318 },
      { name: 'Automotive', attributes: 296 },
      { name: 'Real Estate', attributes: 156 },
      { name: 'Financial', attributes: 160 },
      { name: 'Consumer Interest Index', attributes: 90 },
      { name: 'EAGLES Segmentation', attributes: 76 },
      { name: 'Interests', attributes: 62 },
      { name: 'Donor Behavior', attributes: 27 },
      { name: 'Household Composition', attributes: 36 },
      { name: 'Reading', attributes: 24 },
      { name: 'Behavioral', attributes: 13 },
    ],
  },
};

// For the dashboard KPI cards
export const dashboardKPIs = {
  totalReach: identityGraphStats.individuals,
  totalReachFormatted: '498M',
  activeCampaigns: 12,
  spendToDate: 4_275_000,
  spendFormatted: '$4.28M',
  overallROAS: 4.7,
  suppressionSavings: 892_000,
  suppressionFormatted: '$892K',
  weeklyIntentSignals: identityGraphStats.intentSignals.totalWeekly,
  weeklySignalsFormatted: '25.5B',
  ctvDevices: identityGraphStats.ctv.linkedToIdentity,
  ctvFormatted: '17.4B',
  mobileDevices: identityGraphStats.mobileDevices.total,
  mobileFormatted: '5.9B',
  matchRate: 0.92,
};

// For the identity graph visualization in Intelligence Console
export const deviceGraphSample = {
  personId: 'AA-498231847',
  name: 'Sample Consumer Profile',
  connections: [
    { type: 'email', count: 3, label: '3 Email Addresses' },
    { type: 'phone', count: 2, label: '2 Phone Numbers' },
    { type: 'maid', count: 4, label: '4 Mobile Devices (2 AAID, 2 IDFA)' },
    { type: 'ctv', count: 7, label: '7 CTV Devices (Roku, Fire TV, Apple TV, Samsung)' },
    { type: 'ip', count: 12, label: '12 IP Addresses (2 residential, 10 mobile tower)' },
    { type: 'address', count: 1, label: '1 Postal Address' },
  ],
};
